import type { CertificateFontId } from "../certificates/certificateTemplates";

/** Someone who signs certificates: a name ("H Sookchand") and a title ("Principal"). */
export type SignatureInput = {
  name: string;
  title: string;
};

/** One of the Organization's Signatures. An Award copies the ones it uses. */
export type Signature = SignatureInput & {
  signatureId: string;
};

export type SignatureProblems = Partial<Record<keyof SignatureInput, string>>;

/** The handwriting font every Signature is drawn in. */
export const SIGNATURE_FONT: CertificateFontId = "great-vibes";

export const SIGNATURE_TITLE_SUGGESTIONS = [
  "Principal",
  "Teacher",
  "Pastor",
  "Coach",
];

/** The most characters a name or title may have, as on the server. */
export const SIGNATURE_TEXT_MAX = 60;

/** Trims and collapses spaces, as the server does before saving. */
export function tidySignatureText(value: string): string {
  return value.trim().replace(/\s+/g, " ");
}

export function signatureProblems(input: SignatureInput): SignatureProblems {
  const problems: SignatureProblems = {};
  const name = tidySignatureText(input.name);
  const title = tidySignatureText(input.title);
  if (!name) problems.name = "Enter a name.";
  else if (name.length > SIGNATURE_TEXT_MAX) {
    problems.name = `Use ${SIGNATURE_TEXT_MAX} characters or fewer.`;
  }
  if (!title) problems.title = "Enter a title, like Principal.";
  else if (title.length > SIGNATURE_TEXT_MAX) {
    problems.title = `Use ${SIGNATURE_TEXT_MAX} characters or fewer.`;
  }
  return problems;
}
